import React from "react";
import PropTypes from "prop-types";
import DigiFormSelectStd from "./DigiFormSelect";

class DigiFormLocationsPools extends React.Component {
  state = {
    locationValue: this.props.locationValue,
    poolValue: this.props.poolValue
  };

  render() {
    const {
      locationOptions,
      poolOptions,
      fieldErrors,
      required,
      onChange
    } = this.props;

    return (
      <div>
        <DigiFormSelect
          key="location_id"
          name="location_id"
          label="Location"
          required={required}
          value={this.state.locationValue}
          options={locationOptions}
          onChange={e => this.handleLocationChange(e.target.value, "location_id")}
        />
        <DigiFormSelect
          key="position_id"
          name="position_id"
          label="Pool"
          required={required}
          value={this.state.poolValue}
          options={poolOptions[this.state.locationValue]}
          onChange={e => this.handlePoolChange(e.target.value, "pool_id")}
        />
      </div>
    );
  }

  handleLocationChange = (newValue, key) => {
    this.setState({ locationValue: newValue });
    this.props.onChange(newValue, key);
  };

  handlePoolChange = (newValue, key) => {
    this.setState({ poolValue: newValue });
    this.props.onChange(newValue, key);
  };
}

DigiFormLocationsPools.propType = {
  locationValue: PropTypes.number,
  poolValue: PropTypes.number,
  locationOptions: PropTypes.array,
  poolOptions: PropTypes.array,
  fieldErrors: PropTypes.array,
  required: PropTypes.bool,
  onChange: PropTypes.func
};

DigiFormLocationsPools.defaultProps = {
  fieldErrors: {},
  required: false
};

export default DigiFormLocationsPools;
